/*
 * Copyright (c) 2026 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *   Ipivot Corporation ("Confidential Information").
 */
'use strict';

import { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { getProbesForFinger } from '../data';
import { RowSelectionState } from '@tanstack/react-table';
import ProbeTable from './ProbeTable';
import { StatusContext } from './StatusContext';

function FingerProbesPage() {
    const { fid } = useParams();
    const navigate = useNavigate();
    const statusContext = useContext(StatusContext);
    const [probes, setProbes] = useState<any[]>([]);
    const [probeSelection, setProbeSelection] = useState<RowSelectionState>({});

    useEffect(() => {
        async function loadProbes() {
            try {
                const data = await getProbesForFinger(Number(fid));
                setProbes(Array.isArray(data) ? data : []);
            } catch (error: any) {
                statusContext.postError(`Error loading probes for fid ${fid}: ${error.message}`);
            }
        }
        if (fid) {
            loadProbes();
        }
    }, [fid]);

    return (
        <div className="p-3">
            <div className="d-flex align-items-center gap-3 mb-3">
                <Button variant="outline-secondary" size="sm" onClick={() => navigate(`/fingerprint/${fid}`)}>
                    <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
                    Back to Editor
                </Button>
                <h5 className="mb-0">Probe Activity</h5>
                <span className="badge text-bg-secondary">{probes.length}</span>
            </div>
            <ProbeTable
                rowSelection={probeSelection}
                setRowSelection={setProbeSelection}
                data={probes}
                doSearch={true}
            />
        </div>
    );
}

export default FingerProbesPage;
